import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.NetSuiteRequestCard.NetSuiteItemReceiptItemLines', {
    sectionHeaderText: 'Items',
    receivedColumnName: 'Received',
    receivedTooltip: 'Received',
    itemColumnName: 'Item',
    descriptionColumnName: 'Description',
    locationColumnName: 'Location',
    quantityColumnName: 'Quantity',
    quantityOnHandColumnName: 'Quantity on hand',
    quantityRemainingColumnName: 'Quantity remaining',
    unitPriceColumnName: 'Rate',
    amountColumnName: 'Amount',
});
